import React from 'react';
import { Button } from '@/components/ui/button';
import { ExternalLink, CreditCard } from 'lucide-react';
import { getInvoicePortalUrl, isInvoicePortalConfigured } from '@/lib/zohoConfig';
import { fireEvent } from '@/lib/analytics';

interface ZohoBillingButtonProps {
  variant?: 'default' | 'outline' | 'secondary' | 'ghost';
  size?: 'default' | 'sm' | 'lg';
  source: string;
  domain?: string;
  userEmail?: string;
  className?: string;
}

export default function ZohoBillingButton({
  variant = 'outline',
  size = 'default',
  source,
  domain,
  userEmail,
  className,
}: ZohoBillingButtonProps) {
  const handleBillingPortalClick = () => {
    // Track analytics
    fireEvent('billing_portal_open', {
      source,
      domain: domain || null,
    });

    // Open Zoho Invoice portal
    const portalUrl = getInvoicePortalUrl(userEmail);
    if (portalUrl) {
      window.open(portalUrl, '_blank', 'noopener,noreferrer');
    }
  };

  // Don't render if not configured
  if (!isInvoicePortalConfigured()) {
    return null;
  }

  return (
    <Button variant={variant} size={size} onClick={handleBillingPortalClick} className={className}>
      <CreditCard className="w-4 h-4 mr-2" />
      Manage Billing
      <ExternalLink className="w-4 h-4 ml-2" />
    </Button>
  );
}
